export default "__VITE_ASSET___6Up5W_7__"